// Module
var code = `<tour-step-body><span translate="activity-editor_tour_ai_markers_body"></span></tour-step-body>`;
// Exports
export default code;